import { FormField } from '../form.field';
import { IFormField } from '../form.interface';

export class MobilePhoneField<T = string> extends FormField<T> {
  constructor(args?: IFormField<T>) {
    super({
      ...args,
      ...{ inputType: 'tel', bidi: true, inputMode: 'numeric', inputMethod: 'typing' }
    });
  }
}
